import React from 'react'
import Box from '@material-ui/core/Box';

interface Props {
  audioData: Uint8Array | any;
  left: string;
  right: string;
  rotate: string
}

interface State {
}

type Colors = {
  accent: string;
  fill: string;
  border: string;
  mid: string;
  black: string;
  white: string;
};

type Bar = {
  x: number,
  y: number,
  w: number,
  h: number
};

class AudioVisualiser extends React.Component<Props, State> {

  private canvas: React.RefObject<HTMLCanvasElement>
  private bars: number;
  private bar: Bar;
  private colors: Colors;
  
  constructor(props: Props) {
    super(props);
    this.canvas = React.createRef<HTMLCanvasElement>();
    this.bars = 24
    this.bar = {
      x: 0,
      y: 0,
      w: 20,
      h: 175 / this.bars
    }
    this.colors = {
      'accent': '#ff5500',
      'fill': '#eeeeee',
      'border': '#e3e3e3',
      'mid': '#1af',
      'black': '#000000',
      'white': '#FFFFFF'
    }    
  }

  componentDidUpdate() {
    this.draw();
  }

  draw() {
    const { audioData } = this.props;
    const canvas = this.canvas.current;
    const context = canvas!.getContext('2d');
    context!.fillStyle = this.colors.fill
    context!.fillRect(0, 0, this.canvas.current!.width, this.canvas.current!.height)
    const max = Math.max.apply(null, audioData)
    const min = Math.min.apply(null, audioData)
    let amp = max - min
    amp /= 240

    //converts amps to db
    var db = 20 * (Math.log(amp) / Math.log(10))
    context!.fillStyle = this.colors.fill
    context!.fillRect(0, 0, this.canvas.current!.width, this.canvas.current!.height)

    //scales: -40 to +10 db range => a number of bars
    const dboffset = Math.floor((db + 40) / (50 / this.bars))

    for (let i = 0; i < this.bars; i++) {

      // 0+ db is red
      if (i >= this.bars * .8) {
        context!.fillStyle = '#1064ef'
        // -5 to 0 db is yellow
      } else if (i < this.bars * .8 && i >= this.bars * .69) {
        context!.fillStyle = '#568de6'
        // -40 to -5 db is green
      } else if (i < this.bars * .69) {
        context!.fillStyle = '#4285F4'
      }
      // draw bar
      if (i <= dboffset + 1){
        context!.fillRect(1, this.canvas.current!.height - this.bar.h * i, this.canvas.current!.width - 2, this.bar.h - 2)
      }
    }
  }

  render() {
    return (
      <Box 
        position="absolute"
        top="-73px"
        right={`${this.props.right}px`}
        left={`${this.props.left}px`}
      >
        <canvas 
          width="20" 
          height="175" 
          style={{
            transform: `rotate(${this.props.rotate}deg)`
          }} 
          ref={this.canvas} 
        />
      </Box>
    );
  }
}

export default AudioVisualiser;
